import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const MicOnIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Mic stand */}
      <path
        d="M12 19v3"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Horizontal base line */}
      <line
        x1="9"
        y1="22"
        x2="15"
        y2="22"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
      />

      {/* Outer mic arc */}
      <path
        d="M19 10v2a7 7 0 0 1-14 0v-2"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Mic capsule */}
      <rect
        x="9"
        y="2"
        width="6"
        height="13"
        rx="3"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default MicOnIcon;
